import React from 'react'
import './grid_project.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { convertDay } from '../../../functions/date_converter';
import { useNavigate } from 'react-router-dom';
import { getSolutionMappedTo } from '../../../functions/get_solution_to'
import { shortenText, formatProblemDisplay } from '../../../global/http_enum';

export default function GridProject({ projectData, Selected, hundleSelectProject, SetEditProject, deleteProject }) {
  const navigate = useNavigate();
  let theoryObject = projectData.problem ? projectData.problem.find(obj => obj.domain === projectData.event?.domain) : null;
  
  const handleEditClick = (e) => {
    e.stopPropagation();
    SetEditProject(projectData.id);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    deleteProject(projectData.id);
  };

  return (
    <div 
      onClick={() => { hundleSelectProject(projectData) }} 
      onDoubleClick={() => navigate('/event')} 
      className={`${Selected === projectData.id ? 'project-selected' : ''} project-gird`}
    >
      <div className="project-header">
        <div className="project-header-left">
          <h1 className='project-name'>{projectData.name || 'Project Name goes...'}</h1>
          <div className='project-date'>{convertDay(projectData.updated_at)}</div>
        </div>
        <div className='project-actions'>
          <EditIcon className='edit-icon' onClick={handleEditClick} />
          <DeleteIcon className='delete-icon' onClick={handleDeleteClick} />
        </div>
      </div>
      <div className={`${Selected === projectData.id ? 'project-info-selected' : ''} project-info`}>
        <div className='info-field'>
          <div className='field-label'>Event</div>
          <div className='field-value event-value'>
            {projectData.event ? shortenText(projectData.event.name, 35) : '...'}
          </div>
        </div>
        <div className='info-field'>
          <div className='field-label'>Problem</div>
          <div className='field-value problem-value'>
            {projectData.event ? shortenText(formatProblemDisplay(projectData.event.problem_identifyed_from_event), 35) : '...'}
          </div>
        </div>
        <div className='info-field'>
          <div className='field-label'>Negative Function</div>
          <div className='field-value negative-function-value'>
            {projectData.event ? shortenText(projectData.event.negative_function_exluded, 35) : '...'}
          </div>
        </div>
        <div className='info-field'>
          <div className='field-label'>Solution</div>
          <div className='field-value solution-value'>
            {theoryObject && theoryObject.problem_mapped_to && projectData.event 
              ? shortenText(getSolutionMappedTo(theoryObject.problem_mapped_to, projectData.event.domain)[0] || "...", 35)
              : "..."}
          </div>
        </div>
      </div>
    </div>
  )
}
